import React, { useEffect, useState } from 'react'
import Switch from 'react-switch'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import Select from 'react-select'
import { cheeseTypeOptions, fatLevelOptions } from './constants'
import PropTypes from 'prop-types'

const CheesePackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    FatLevel: item.FatLevel,
    Type: item.Type,
    Size: item.Size,
    MadeInUSA: item.MadeInUSA,
    Kosher: item.Kosher,
  })
  const methods = useFormContext()
  const { setSelectReviewer, setSwitchReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item) {
      const { FatLevel, Type, Size, MadeInUSA, Kosher } = item
      setPackaging({
        FatLevel,
        Type,
        Size,
        MadeInUSA: MadeInUSA || false,
        Kosher: Kosher || false,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Fat Level {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={fatLevelOptions}
          defaultValue={{
            label: packaging.FatLevel,
            value: packaging.FatLevel,
          }}
          name="FatLevel"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Fat Level'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="FatLevel"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          name="Type"
          placeholder={'Select Cheese Type'}
          options={cheeseTypeOptions}
          defaultValue={{
            label: packaging.Type,
            value: packaging.Type,
          }}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          control={methods.control}
          rules={{ required: true }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="Type"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Input defaultValue={packaging.Size} disabled />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <br />
        <p>
          <strong>
            I verify that this product is made in the USA {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="MadeInUSA"
          id="MadeInUSA"
          defaultValue={packaging.MadeInUSA}
          onChange={([checked, event, id]) => {
            setSwitchReviewer(item, checked, event, id)
            return checked
          }}
          control={methods.control}
          checked={packaging.MadeInUSA}
          rules={{ validate: MadeInUSA => MadeInUSA === true }}
          disabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="MadeInUSA"
            message={'⚠ Product must be made in the USA.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <hr />
        <p>
          <strong>Kosher</strong>
        </p>
        <Controller
          as={Switch}
          name="Kosher"
          id="Kosher"
          defaultValue={packaging.Kosher}
          onChange={([checked, event, id]) => {
            setSwitchReviewer(item, checked, event, id)
            return checked
          }}
          control={methods.control}
          disabled={isDisabled}
        />
      </Col>
    </Row>
  )
}

CheesePackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default CheesePackageReview
